import * as React from 'react'
import GroupsLIstNavbar from './GroupsLIstNavbar'
import GroupsListItem from './GroupsListItem'
import { GroupModel } from '@/modules/drivers/types/groups'
import { faUsersRegular, faUsersSolid } from '@/lib/fa'

const GroupsCustomList = ({
  groups,
  defaultChecked = false,
}: {
  groups: GroupModel[]
  defaultChecked?: boolean
}) => {
  return (
    <div>
      <GroupsLIstNavbar title="Autorskie" />
      <div className="tw-flex tw-flex-col">
        {groups.map((group) => (
          <GroupsListItem
            key={group.id}
            group={group}
            solidIcon={faUsersSolid}
            regularIcon={faUsersRegular}
          />
        ))}
      </div>
    </div>
  )
}

export default GroupsCustomList
